import { StyleProp, Text, TextStyle } from 'react-native';
import { UnvalidatedStyles } from '@shared/components/MBText';
import type { TextProps } from './MBTypographyTypes';
import { MBTypographyStyles } from './typographyStyles';

interface PrivateTextProps {
  style?: StyleProp<TextStyle>;
}

export function TypographyTextBase({
  numberOfLines,
  ellipsizeMode,
  lineThrough,
  children,
  align,
  color,
  style,
  allowFontScaling,
  flex,
  onPress,
  testID,
  selectable,
}: TextProps & PrivateTextProps) {
  return (
    <Text
      allowFontScaling={allowFontScaling}
      numberOfLines={numberOfLines}
      ellipsizeMode={ellipsizeMode}
      onPress={onPress}
      testID={testID}
      style={[
        MBTypographyStyles.default,
        !!numberOfLines && UnvalidatedStyles.numberOfLines(numberOfLines),
        lineThrough && MBTypographyStyles.lineThrough,
        !!align && { textAlign: align },
        style,
        !!color && { color },
        flex && { flex: 1 },
      ]}
      selectable={selectable}
    >
      {children}
    </Text>
  );
}
